import Noty from 'noty';
import EventEmitter from 'events';
import 'noty/src/noty.scss';
import 'noty/src/themes/metroui.scss';

Noty.overrideDefaults({
  layout: 'bottomRight',
  timeout: 2000,
  theme: 'metroui'
});

const notyEmitter = new EventEmitter();
export { notyEmitter };

export default {
  success(message, options) {
    return new Noty({
      ...options,
      type: 'success',
      text: message
    }).show();
  },
  errors(error, options) {
    // console.log(typeof error);
    if (typeof error === 'string') {
      return new Noty({
        ...options,
        type: 'error',
        text: error
      }).show();
    } else if (
      error.message &&
      error.errors &&
      Object.values(error.errors).length === 0
    ) {
      return new Noty({
        ...options,
        type: 'error',
        text: error.message
      }).show();
    } else if (error.errors && Object.values(error.errors).length > 1) {
      let messages = '';
      Object.values(error.errors).forEach(err => {
        messages += `<li>${err.message}</li>`;
      });
      return new Noty({
        ...options,
        type: 'error',
        text: `<ul>${messages}</ul>`
      }).show();
    } else if (error.errors && Object.values(error.errors).length === 1) {
      let message = '';
      Object.values(error.errors).forEach(err => {
        message = err.message;
      });
      return new Noty({
        ...options,
        type: 'error',
        text: message
      }).show();
    } else if (!error.errors && error.message) {
      return new Noty({
        ...options,
        type: 'error',
        text: error.message
      }).show();
    } else {
      return new Noty({
        ...options,
        type: 'error',
        text:
          'Something went wrong. Please try again or refresh the page if the problem persists.'
      }).show();
    }
  },
  confirm(message, options) {
    notyEmitter.emit('confirm', { message, options });
  }
};



// WEBPACK FOOTER //
// ./src/lib/noty.js